/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Filters from "../Filters/index.js";
import { ControlTable } from "../Table/index.js";
import { findIndex, get, isEmpty } from "lodash";
import { downExcelFile } from "../../utils/download.js";
import { viewLoading } from "../../utils/loading.js";
import useForm from "../../hooks/useForm.js";
import { getParams } from "../../utils/params.js";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import systemAlert from "../../utils/systemAlert.js";
import { deleteMappingManagementGroup, getManagementList } from "../../apis/tax-portal/index.js";
import { MANAGEMENT_TYPE } from "../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE.js";
import { custodianPreview } from "../../utils/custodian.js";
import Custodian from "./Custodian.js";
import { scrapingTaxpayerFromHometax } from "../../apis/tax-accountant-finance/auth.js";
import { useHistory } from "react-router-dom";
import { dateToViewFormat } from "../../utils/date.js";
import { isTaxAccountantAccountCheck } from "../../utils/taxPortal/tax-accountant.js";
import ToolTip from "../ToolTip/ToolTip.js";
import { companiesCheckedList, companiesToTaxpayer, getTaxpayerDownloadExcel } from "../../apis/tax-portal/taxpayer.js";
import { toast } from "../../utils/toast.js";
import TaxpayerFileUpload from "./TaxpayerFileUpload.js";
import IconButton from "../Button/IconButton.js";
import DeleteIcon from "../../assets/images/icon/delete-icon-01.svg";
import Button from "../Button/index.js";
import { createBizCompany, createMasterPassword, updateMasterPassword } from "../../apis/companies/companies.js";
import { textAreaClipboardCopy } from "../../utils/browser.js";
import { getStoreCompanies, getTaxpayerList } from "../../store/actions.js";
import TaxpayerManager from "./TaxpayerManager.js";
import CustodianExpiredModal from "./CustodianExpiredModal.js";
import { getPartnerSite } from "../../apis/partner/partner-site.js";


const defaultForm = {
  search: {
    isUse: "1",
    isWecake: "2",
    isIncludeClose: "0",
  },
  page: 0,
  limit: 10,
};

const Custodians = ({ tabList, activeTab, targetPermission }) => {
  const {
    previewCustodian,
    careCompanies,
    taxContactType,
    managerEmployees,
    user,
    companies,
    managerRole,
  } = useSelector((store) => ({
    previewCustodian: store.Custodian.previewCustodian,
    careCompanies: store.Data.careCompanies,
    taxContactType: store.TaxPortal.taxContactType,
    managerEmployees: store.Data.managerEmployees,
    user: store.Profile.user,
    companies: store.Data.companies,
    managerRole: store.Profile.managerRole,
  }), shallowEqual);

  const [fields, setFields] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [managerOpen, setManagerOpen] = useState(false);
  const dispatch = useDispatch();

  const [fileUploadOpen, setFileUploadOpen] = useState(false);
  const [myCompany, setMyCompany] = useState({});
  const [partnerSite, setPartnerSite] = useState(null);

  const [sortFields, setSortFields] = useState([
    { key: "startDate", order: "desc" },
    { key: "companyName", order: "" },
    { key: "bsno", order: "" },
    { key: "ceoName", order: "" },
    // { key: "expiredDate", order: "" },
    { key: "createdTime", order: "" },
  ]);

  const history = useHistory();
  const [filters, setFilters] = useState([]);

  const [expiredOpen, setExpiredOpen] = useState(false);



  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];

    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };

    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  const handleRemoveMapping = (data, group) => {

    const taxpayerIdx = data.idx;
    const taxpayerGroupIdx = group.idx;

    systemAlert(`수임처 "${data.companyName}"에 매핑된 그룹 [${group.name}]를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteMappingManagementGroup({
              taxpayerIdx,
              taxpayerGroupIdx
            })
              .then(() => {
                toast.success("완료되었습니다.");
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(companies))
      setMyCompany(companies.find((com) => com.companyIdx === user.managerCompanyIdx));
  }, [user, companies]);

  useEffect(() => {
    const _filters = [
      {
        title: "상호명 또는 대표명 검색",
        type: "input",
        key: "search.keyword",
        placeholder: "상호명 또는 대표명 입력",
      },
      {
        title: "사업자번호 검색",
        type: "input",
        key: "search.bsno",
        placeholder: '"-" 제외하고 입력',
      },
      {
        title: "그룹 검색",
        type: "input",
        key: "search.groupName",
        placeholder: "그룹명 입력",
      },
      {
        title: '주담당자',
        type: 'searchEmployees',
        key: 'search.managerEmployees',
        isHide: () => managerRole?.type > 2,
        options: {
          isTax: true,
        },
      },
      {
        title: "수임여부",
        type: "select",
        key: "search.isUse",
        className: "margin-right-16",
        options: {
          list: [
            { label: "전체", value: "2" },
            { label: "사용중", value: "1" },
            { label: "중지", value: "0" },
          ],
        },
        placeholder: "그룹명 입력",
      },
      {
        title: "wecake Biz 사용여부",
        type: "select",
        key: "search.isWecake",
        className: "margin-right-16",
        options: {
          list: [
            { label: "전체", value: "2" },
            { label: "사용중", value: "1" },
            { label: "사용안함", value: "0" },
          ],
        },
        placeholder: "그룹명 입력",
      },
      {
        title: "폐업 포함여부",
        type: "select",
        key: "search.isIncludeClose",
        options: {
          list: [
            { label: "폐업 제외", value: "0" },
            { label: "폐업 포함", value: "1" }
          ]
        }
      },
    ];
    setFilters(_filters);
  }, [managerEmployees, managerRole]);

  useEffect(() => {
    setFields(
      [
        {
          title: "구분",
          key: "type",
          onValue: (d) =>
            (d || []).map(type =>
              MANAGEMENT_TYPE.find(f => f.value === type)?.label || ""
            ).join(',')

        },
        {
          title: "그룹", key: "groups", onValue: (v, _f, d) => {
            return (
              !isEmpty(v) && (
                v.map((item, idx) => {
                  return (
                    <p className="pt-8 pb-8" key={idx}>
                      <span className="vertical-middle">
                        {item.name}
                      </span>
                      {targetPermission.level > 1 && (
                        <IconButton
                          className="ml-4 vertical-middle" icon={DeleteIcon}
                          action={() => handleRemoveMapping(d, item)}
                        />
                      )}
                    </p>
                  );
                })
              )
            );
          },
        },
        {
          title: "주담당자",
          key: "taxpayerManagerEmployees",
          onValue: (v, _f, d) => {
            return v?.filter(f => f.companyManagerPerson?.level === 1).map(f => f.name).join(',') || "-";
          }
        },
        {
          title: "수임회사명",
          key: "companyName",
          onValue: (v, _f, d) => {
            const isChange = v !== d.txprNm;
            return (
              <>
                <span className={`${isChange ? "font-bold" : ""}`}>{v}</span>
                {isChange && <span className="error ml-5">*</span>}
              </>
            );
          },
          sort: (key) => handleSort(key), order: (key) => orderKey(key)
        },
        {
          title: "대표자명",
          key: "ceoName",
          onValue: (v, _f, d) => {
            const isChange = v !== d.rprsTxprNm;
            return (
              <>
                <span className={`${isChange ? "font-bold" : ""}`}>{v}</span>
                {isChange && <span className="error ml-5">*</span>}
              </>
            );
          },
          sort: (key) => handleSort(key), order: (key) => orderKey(key)
        },

        {
          title: "사업자등록번호",
          key: "bsno",
          transform: "comNum",
          sort: (key) => handleSort(key), order: (key) => orderKey(key)
        },
        {
          title: "수임일",
          key: "startDate",
          onValue: (v) => v ? dateToViewFormat(v) : "-",
          sort: (key) => handleSort(key), order: (key) => orderKey(key)

        },
        {
          title: "수임여부",
          key: "isUse",
          onValue: (value) => {
            if (value) {
              return (<>O</>);
            } else {
              return (<>X</>);
            }
          }
        },
        {
          title: "wecake Biz 사용여부",
          key: "companyToTaxpayer.company",
          onValue: (value, _f, d) => {
            if (!isEmpty(value)) {
              return (<>O</>);
            } else {
              return (
                <Button
                  size="x-sm"
                  color="line"
                  onClick={() => {
                    viewLoading('wecake biz 생성중입니다.');
                    createBizCompany({ taxpayerIdx: d.idx })
                      .then(res => {
                        reSubmit();
                        dispatch(getTaxpayerList());
                        dispatch(getStoreCompanies());
                        if (res.data?.password) {
                          textAreaClipboardCopy(`아이디 : ${d.bsno}\n비밀번호 : ${res.data.password}\nhttps://${!isEmpty(partnerSite.url) ? `${partnerSite.url}` : 'web'}.wecake.io`, undefined, false);
                          systemAlert(`wecake biz가 생성되었습니다.
마스터계정의 ID는 회사 사업자번호(-제외)이고
패스워드는 "${res.data.password}"입니다.
아이디와 패스워드가 클립보드에 복사되었습니다.`);
                        }
                      }).catch(err => {
                        console.error(err);
                      }).finally(() => {
                        viewLoading(false);
                      });
                    // }
                  }}
                >
                  {careCompanies.find(f => f.comNum === d.bsno) ? "wecake Biz 연동하기" : "wecake Biz 생성하기"}
                </Button>
              );
            }
          }
        },
        {
          title: <>마스터 패스워드<ToolTip tooltiptext={"아이디는 -를 제외한 사업자번호입니다.\n비밀번호는 [Biz - 관리중인 기업관리]에서 확인하실 수 있습니다.\n 비밀번호를 변경하시면 클립보드에 자동 복사 됩니다."} /></>,
          key: "companyToTaxpayer.company.masterPassword",
          onValue: (value, _f, d) => {
            if (!isEmpty(value)) {
              return (
                <Button
                  size="x-sm"
                  color="gray-line"
                  onClick={() => updateMasterPassword(d?.companyToTaxpayer?.companyIdx)
                    .then((res) => {
                      textAreaClipboardCopy(`아이디 : ${d.bsno}\n비밀번호 : ${res.data}\nhttps://${!isEmpty(partnerSite?.url) ? `${partnerSite.url}` : 'web'}.wecake.io`, undefined, false);
                      systemAlert(`마스터계정 패스워드가 변경되었습니다.
마스터계정의 ID는 회사 사업자번호(-제외)이고
패스워드는 "${res.data}"입니다.
아이디와 패스워드가 클립보드에 복사되었습니다.`);
                      toast.success('변경이 완료되었습니다.');
                    })}
                >
                  변경하기
                </Button>
              );
            } else {
              const companyIdx = d?.companyToTaxpayer?.companyIdx;
              return (
                isEmpty(d?.companyToTaxpayer?.company) ?
                  <>사용불가<ToolTip tooltiptext="wecake Biz를 생성하신 후에 사용이 가능합니다." /></>
                  :
                  careCompanies.find(f => f.companyIdx === companyIdx) ?
                    <Button
                      size="x-sm"
                      color="line"
                      onClick={() => {
                        createMasterPassword(companyIdx)
                          .then(res => {
                            textAreaClipboardCopy(`아이디 : ${d.bsno}\n비밀번호 : ${res.data.password}\nhttps://${!isEmpty(partnerSite.url) ? `${partnerSite.url}` : 'web'}.wecake.io`, undefined, false);
                            systemAlert(`wecake biz마스터계정이 생성되었습니다.
마스터계정의 ID는 회사 사업자번호(-제외)이고
패스워드는 "${res.data.password}"입니다.
아이디와 패스워드가 클립보드에 복사되었습니다.`);
                            reSubmit();
                          });
                      }}
                    >
                      발급하기
                    </Button>
                    : <>사용불가<ToolTip tooltiptext="wecake Biz의 기업 담당자만 사용 가능합니다." /></>

              );
            }
          }
        },
        {
          title: "등록일자",
          key: "createdTime",
          type: "date",
          sort: (key) => handleSort(key), order: (key) => orderKey(key)
        },
      ],
    );
  }, [sortFields, careCompanies, partnerSite]);

  useEffect(() => {
    if (previewCustodian === null && !isEmpty(list)) {
      setSelectedList([]);
      reSubmit();
    }
  }, [previewCustodian]);

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedList,
    setSelectedList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    reSubmit: _reSubmit,
    setOrderBy,
    // isSubmit
  } = useForm(defaultForm);

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    if (!isEmpty(myCompany)) {
      getPartnerSite(myCompany.companyIdx)
        .then(res => {
          res.isActive && setPartnerSite(res);
        });
    }
  }, [myCompany]);

  const reSubmit = () => {
    dispatch(getTaxpayerList());
    dispatch(getStoreCompanies());
    _reSubmit();
  };


  const [isFirst, setIsFirst] = useState(true);
  useEffect(() => {
    if (taxContactType && targetPermission) {
      setIsLoading(true);
      setSubmit(submit);
      setForm({ ...form, ...defaultForm });
      if (!isFirst) {
        submit({ ...form, ...defaultForm })
      } else {
        setIsFirst(false)
      }
    }

  }, [targetPermission, taxContactType]);

  const submit = (params) => {
    setIsLoading(true);
    getManagementList(_getParams(params))
      .then(res => {
        setTotal(get(res, "managementList.count", 0));
        setList(get(res, "managementList.rows", []));
      })
      .finally(() => setIsLoading(false));
  };

  const _getParams = (params) => {
    params = {
      ...params,
      search: {
        ...params?.search,
        isUse: !isEmpty(params?.search?.isUse) ? +params?.search?.isUse : 2,
        isWecake: !isEmpty(params?.search?.isWecake) ? +params?.search?.isWecake : 2,
        isIncludeClose: !isEmpty(params?.search?.isIncludeClose) ? +params?.search?.isIncludeClose : 1,
        employeeIdx: params?.search?.managerEmployees?.map(item => item.idx)
      },
      taxSearchType: taxContactType
    };

    delete params?.search?.managerEmployees;
    return getParams(params);
  };

  const _getTaxAccountantHometaxTaxpayers = async () => {

    viewLoading('홈택스에서 수임처 목록을 불러오는 중입니다.\n잠시만 기다려주세요.');
    await scrapingTaxpayerFromHometax();
    viewLoading(false);
    submit(form);
  };

  const getTaxAccountantHometaxTaxpayers = async () => {
    const isAccountCheck = await isTaxAccountantAccountCheck();
    if (!isAccountCheck) {
      systemAlert('홈택스 로그인정보가 없습니다.\n홈택스 설정 메뉴로 이동하시겠습니까?', {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: '이동',
            onClick: () => {
              history.push('/tax-portal/settings/hometax');

            },
          },
        ]
      });
      return;
    }
    await _getTaxAccountantHometaxTaxpayers();
  };

  // eslint-disable-next-line no-unused-vars
  const _companiesToTaxpayer = async () => {
    companiesCheckedList()
      .then(res => {
        if (!isEmpty(res)) {
          systemAlert(`수임처로 등록되지 않은 총 ${res.length}개의 회사\n${res.map(item => `"${item.name}"`).join(',\n')} \n가 검색되었습니다. 모두 수임처로 등록하시겠습니까?`,
            {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '모두등록',
                  onClick: () => {
                    viewLoading("wecake 관리회사 등록중입니다.");
                    companiesToTaxpayer({ companyIdx: res.map(item => item.idx) })
                      .then(res => {
                        toast.success("등록이 완료되었습니다.");
                        reSubmit();
                      })
                      .finally(() => viewLoading(false));
                  }
                }
              ]
            }
          );
        } else {
          systemAlert("wecake Biz가 모두 수임처로 등록되어 있습니다.");
        }
      }).finally(() => viewLoading(false));
  };

  const headerButtons = [
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "해임일 설정",
      color: "red",
      action: () => setExpiredOpen(true),
      disabled: isEmpty(selectedList)
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "매니저 설정",
      action: () => setManagerOpen(true),
      disabled: isEmpty(selectedList)
    },
    // {
    //   isHide: !(targetPermission && targetPermission.level > 1),
    //   label: "관리회사 수임처 등록",
    //   action: () => _companiesToTaxpayer()
    // },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "엑셀업로드",
      color: "gray-line",
      action: () => {
        setFileUploadOpen(true);
      },
    },
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        viewLoading(true);
        getTaxpayerDownloadExcel(_getParams(form))
          .then((res) => {
            downExcelFile(res, "수임회사_목록.xlsx");
          }).finally(() => viewLoading(false));
      },
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "수임처 추가",
      action: () => {
        setDetailOpen(true);
      },
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "홈택스 수임처불러오기",
      action: () => {
        getTaxAccountantHometaxTaxpayers();
      },
    },
  ];

  const openDetail = (data, e) => {
    const { tagName } = e.target;
    if (tagName !== "TR" && tagName !== "TD" && tagName !== "SPAN") return;
    custodianPreview(data.idx);
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isControl
          sortField={sortFields.find((field) => !isEmpty(field.order))}
          fields={fields}
          list={list}
          buttons={targetPermission.level > 1 ? headerButtons : []}
          selectedList={selectedList}
          setSelected={setSelectedList}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          onSelect={openDetail}
          submit={handleSubmit}
        />
        <Custodian
          permission={targetPermission}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={reSubmit}
        />

        <TaxpayerFileUpload
          filterSubmit={filterSubmit}
          open={fileUploadOpen}
          setOpen={setFileUploadOpen}
        />

        <TaxpayerManager
          open={managerOpen}
          setOpen={setManagerOpen}
          taxpayerList={selectedList}
          setTaxpayerList={setSelectedList}
          list={[myCompany]}
          submit={reSubmit}
        />

        <CustodianExpiredModal
          open={expiredOpen}
          setOpen={setExpiredOpen}
          taxpayerList={selectedList}
          setTaxpayerList={setSelectedList}
          submit={reSubmit}
        />
      </>
    )
  );
};

export default Custodians;
